import React from 'react';

import { QueryContainer } from '@components/QueryContainer';
import { cellFactory, Table } from '@components/Table/Table';
import { staffStrings } from '@data/staff';
import { useAgencyList } from '@hooks/queries/dashboard/useAgencyList';
import { mapRoleToRoleOptionLabel } from '@models/Role';
import { Staff } from '@models/Staff';
import { UserHelper } from '@models/User';
import { formatDateTime } from '@utils/types';

interface StafftableProps {
  staffList: Staff[];
}

export const StaffTable: React.FC<StafftableProps> = (props) => {
  const { staffList } = props;
  const agencyList = useAgencyList();

  return (
    <QueryContainer queries={[agencyList]}>
      <Table>
        <Table.Head>
          <Table.Row
            columns={[
              cellFactory.create(staffStrings.staff_id),
              cellFactory.create(staffStrings.name),
              cellFactory.create(staffStrings.role),
              cellFactory.create(staffStrings.email),
              cellFactory.create(staffStrings.lastLoginTime),
            ]}
          />
        </Table.Head>
        <Table.Body>
          {staffList?.map((item) => (
            <Table.Row
              columns={[
                cellFactory.create(item.staff_id || ''),
                cellFactory.create(new UserHelper(item).fullname || ''),
                cellFactory.create(
                  mapRoleToRoleOptionLabel(
                    item.role,
                    agencyList.data?.find((agency) => agency.id === item.agency_id)?.name_en_short,
                  ) || '',
                ),
                cellFactory.create(item.email || ''),
                cellFactory.create((item.last_login && formatDateTime(item.last_login)) || ''),
              ]}
            />
          ))}
        </Table.Body>
      </Table>
    </QueryContainer>
  );
};
